import * as Sentry from '@sentry/react';

export function trackError(error: unknown, context?: Record<string, unknown>): void {
  if (import.meta.env.DEV) {
    // In dev, log to console for easier debugging
    console.error('Tracked error:', error, context);
    return;
  }

  Sentry.captureException(error, {
    extra: context,
  });
}
